var map = {
	"./0.png": 286,
	"./1.png": 603,
	"./10.png": 169,
	"./11.png": 301,
	"./2.png": 440,
	"./3.png": 69,
	"./4.png": 437,
	"./5.png": 120,
	"./6.png": 283,
	"./7.png": 574,
	"./8.png": 384,
	"./9.png": 321
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 978;